import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const Unloader = createSvg({
  name: 'unloader',
  path: /*#__PURE__*/createElement("g", {
    id: "unloader"
  }, /*#__PURE__*/createElement("path", {
    d: "M63.21 49.09v7.41h-4.94v2.06c0 .45-.37.82-.82.82H46.6v1.97h-2.47v7.41c0 .45-.37.82-.82.82h-5.77c-.45 0-.82-.37-.82-.82v-7.41h-2.47v-4.03c0-.45-.37-.82-.82-.82h-7.28v-7.41h8.1v-5.86h-1.1v-10.7h1.92v-17.3c0-.45.37-.82.82-.82h9.06c.45 0 .82.37.82.82v17.3h1.92v10.71h-1.1v2.97h10.85c.45 0 .82.37.82.82v2.06h4.95z"
  }))
});

export default Unloader;
